import React, { useRef, useContext, useState, useEffect } from "react";
import { GoogleMapsContext } from "../../context/GoogleMapsProvider";
import { GoogleMap, DirectionsRenderer } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "300px",
  borderRadius: "12px",
};

const GoogleMapView = ({ origin, destination }) => {
  const { isLoaded } = useContext(GoogleMapsContext);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [directions, setDirections] = useState(null);

  // Calcul des directions
  useEffect(() => {
    if (!isLoaded || !origin || !destination) return;

    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      { origin, destination, travelMode: window.google.maps.TravelMode.DRIVING },
      (result, status) => {
        if (status === "OK") setDirections(result);
        else console.error("Erreur Directions API :", status);
      }
    );
  }, [isLoaded, origin, destination]);

  // Création du marker dès que la carte est complètement chargée
  const handleMapLoad = async (map) => {
    mapRef.current = map;

    if (!origin) return;

    // Import du module marker moderne
    const { Marker } = await window.google.maps.importLibrary("marker");

    // Création du marker
    markerRef.current = new Marker({
      map: mapRef.current,
      position: origin,
    });
  };

  // Mise à jour du marker si origin change
  useEffect(() => {
    if (markerRef.current && origin) {
      markerRef.current.setPosition(origin);
      mapRef.current?.panTo(origin); // recentre la carte automatiquement
    }
  }, [origin]);

  if (!isLoaded) return <p>Chargement de la carte...</p>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={origin}
      zoom={14}
      onLoad={handleMapLoad}
    >
      {directions && <DirectionsRenderer directions={directions} />}
    </GoogleMap>
  );
};

export default GoogleMapView;
